import { createRouter, createWebHistory } from 'vue-router';
import { useAuth } from '../composables/useAuth';
import AppShell from '../components/AppShell.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/sign-in',
      component: () => import('../views/SignInView.vue'),
      beforeEnter: () => {
        const { isAuthenticated, isAdmin } = useAuth();
        if (isAuthenticated.value && isAdmin.value) return '/dashboard';
      },
    },
    {
      path: '/',
      component: AppShell,
      meta: { requiresAdmin: true },
      children: [
        { path: '',          redirect: '/dashboard' },
        { path: 'dashboard', component: () => import('../views/DashboardView.vue') },
        { path: 'ledger',    component: () => import('../views/LedgerView.vue')    },
        { path: 'expenses',  component: () => import('../views/ExpensesView.vue')  },
        { path: 'payouts',   component: () => import('../views/PayoutsView.vue')   },
        { path: 'reports',   component: () => import('../views/ReportsView.vue')   },
        { path: 'accounts',  component: () => import('../views/AccountsView.vue')  },
      ],
    },
  ],
  scrollBehavior(_to, _from, saved) {
    return saved ?? { top: 0 };
  },
});

router.beforeEach((to) => {
  const { isAuthenticated, isAdmin } = useAuth();
  if (to.meta.requiresAdmin) {
    if (!isAuthenticated.value) return '/sign-in';
    if (!isAdmin.value)         return '/sign-in';
  }
});

export default router;
